import { createSlice } from '@reduxjs/toolkit';
import { setReportSonographer } from '../../../rtk-apis/reports/setReportSonographer';

const initialState = {
  status: '',
  data: null as { sonographerName?: string } | null,
  msg: '',
  loading: false,
};

const setReportSonographerSlice = createSlice({
  name: 'setReportSonographerSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.data = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(setReportSonographer.pending, state => {
        state.loading = true;
      })
      .addCase(setReportSonographer.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data || null;
        state.msg = action?.payload?.message;
      })
      .addCase(setReportSonographer.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.data = null;
        state.msg = (action?.payload as string) || 'Something went wrong';
      });
  },
});

export const { clearState } = setReportSonographerSlice.actions;
export default setReportSonographerSlice.reducer;
